import declint from 'utils/declint';
import { getAccumulatorInfo } from 'utils/accumulators';

const getDays = (period) => declint(
  period,
  ['день', 'дня', 'дней'],
);

const accumulatorsUnits = {
  data: 'KBYTE',
  voice: 'SECONDS',
  sms: 'SMS',
};

const humanizeAccumulatorInfo = (rest, packageType) => {
  if (packageType === 'SMS') {
    return `${rest} SMS`;
  }
  const { value, unit } = getAccumulatorInfo({ rest, unit: packageType });
  return `${value} ${unit}`;
};

const replaceString = (str) => {
  if (str) {
    str = str.replace('\\r\\n', '<br>');
  }
  return str;
};

const isStringEmpty = (str) => !str?.trim().length;

export { accumulatorsUnits, humanizeAccumulatorInfo, replaceString, getDays, isStringEmpty };
